import React from 'react';
import Text from '../Text/index';
import { CareersVisionSection } from './styles';

const CareersVision = ({ img, mobileImg, ...otherProps }) => (
  <CareersVisionSection {...otherProps}>
    <Text
      type={'h2'}
      alignDesktop={'center'}
      size={'28px'}
      className="careers--underlined-heading"
      id="ourvision"
    >
      Vision
    </Text>
    <div className="careers--vision-content-wrapper">
      <div className="careers--vision-content-container">
        <div className="careers--vision-copy-container">
          <div className="careers--vision-copy-container-bg">
            <div className="careers--vision-copy-wrap">
              <Text type={'h3'} className="careers--vision-heading" color={'white'}>
                Creating the operating system for the trades.
              </Text>
              <Text type={'p'} className="careers--vision-body" color={'white'}>
                “We are on a quest to become the first software company to power an entire, global,
                trillion dollar industry end-to-end and bring prosperity to millions of underserved,
                hard-working men and women.” – Ara & Vahe
              </Text>
            </div>
          </div>
        </div>
        <img src={img} className="careers--vision-desktop-img" />
        <img src={mobileImg} className="careers--vision-mobile-img" />
      </div>
    </div>
  </CareersVisionSection>
);

export default CareersVision;
